/**
 * MFA Service — login-time API client.
 *
 * Used between the password step and the session-cookie issuance. The
 * mfa_token is sent in BOTH the X-MFA-Token header AND the body, matching
 * the server's defence-in-depth check in /verify.
 *
 * On successful verify the server sets the access_token cookie in the
 * response. fetch() with credentials:'include' accepts that cookie.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

async function postWithMfaToken(endpoint, mfaToken, body) {
  const response = await fetch(`${BACKEND_URL}${endpoint}`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-MFA-Token': mfaToken,
    },
    body: JSON.stringify(body),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(data.detail || `HTTP ${response.status}`);
    err.status = response.status;
    err.detail = data.detail;
    throw err;
  }
  return data;
}

export const challengeFactor = async (mfaToken, factorType) =>
  postWithMfaToken('/api/auth/mfa/challenge', mfaToken, {
    mfa_token: mfaToken,
    factor_type: factorType,
  });

export const verifyFactor = async (mfaToken, factorType, code, rememberDevice = false) =>
  postWithMfaToken('/api/auth/mfa/verify', mfaToken, {
    mfa_token: mfaToken,
    factor_type: factorType,
    code,
    remember_device: rememberDevice,
  });
